import { cva } from 'class-variance-authority';

export const cvaWrapper = cva(['WrapperStyles-cvaWrapper', 'pt-6']);
